import { useEffect, useState } from "react";
import BannerBg from "../../images/construction-2.jpg";
import AngleR from "../../images/icons/angleR.svg";
import { fetchData } from "../../api";





export default function Banner() {


    const [vacancyBanner, setVacancyBanner] = useState(null);
    useEffect(() => {
        fetchData("vacancy-banners", true).then(data => setVacancyBanner(data?.[0]));
    }, []);

    return (
        <main className="pb-20 max-sm:pb-0">
            <div className="relative w-full  before:bg-[#000]/50 before:backdrop-blur-[0px] before:absolute before:left-0 before:top-0 before:w-full before:h-full max-sm:h-[360px]">
                <img src={BannerBg} alt="" className="w-full h-full lg:max-h-[800px] object-cover" />
                <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 z-20 max-sm:w-full">
                    <h1 className="text-white mb-6 max-sm:text-center">{vacancyBanner?.Title}</h1>
                    <ul className="flex items-center justify-center gap-5">
                        <li className="flex items-center gap-3"><a href={vacancyBanner?.HomeBtnUrl} className="font-semibold">{vacancyBanner?.HomeBtn}</a> <img src={AngleR} className="h-3" /></li>
                        <li><a href={vacancyBanner?.PageUrl} className="font-semibold">{vacancyBanner?.PageName}</a></li>
                    </ul>
                </div>
            </div>
        </main>
    );
}